/**
 * Appreciation members can carry several photos so one card can thank a group
 * ("Aromal, Sooraj, Arun & Anish") instead of a single person.
 *
 * Newsletters saved before this stored one `photoUrl`. `memberPhotos` reads
 * both shapes and `setMemberPhotos` writes both — `photoUrls` for the gallery
 * plus `photoUrl` kept pointing at the first photo — so older rows keep
 * rendering and nothing needs a data migration.
 */
export const MAX_MEMBER_PHOTOS = 5;

/** Photos of a member, newest shape first, always an array. */
export function memberPhotos(member) {
  const list = member?.photoUrls;
  if (Array.isArray(list)) return list.filter(Boolean).slice(0, MAX_MEMBER_PHOTOS);
  return member?.photoUrl ? [member.photoUrl] : [];
}

/** Patch that stores `urls` on a member, capped and de-duplicated. */
export function setMemberPhotos(urls) {
  const next = [...new Set((urls || []).filter(Boolean))].slice(0, MAX_MEMBER_PHOTOS);
  return { photoUrls: next, photoUrl: next[0] || null };
}
